import React, { } from 'react';
import s from './s.module.less';
import TabContent from '../TabContent';
import { EKlarityPage } from 'types/helloKlarity';

const MedicationPage = () => {
    const [key, setKey] = React.useState<EKlarityPage>(EKlarityPage.MED_HOME);

    return (
        <div className={s.wrap}>
            <div className={s.nav}>
                <div className={`${s.navItem} ${key === EKlarityPage.MED_HOME ? s.active : ''}`} onClick={() => setKey(EKlarityPage.MED_HOME)}>
                    <div className={s.navItemTitle}>Homepage</div>
                </div>
                <div className={`${s.navItem} ${key === EKlarityPage.MED_LISTING_PAGE ? s.active : ''}`} onClick={() => setKey(EKlarityPage.MED_LISTING_PAGE)}>
                    <div className={s.navItemTitle}>Listing pages</div>
                </div>
            </div>
            <div className={s.content}>
                {
                    key === EKlarityPage.MED_HOME && (
                        <TabContent type={EKlarityPage.MED_HOME} />
                    )
                }
                {
                    key === EKlarityPage.MED_LISTING_PAGE && (
                        <TabContent type={EKlarityPage.MED_LISTING_PAGE} />
                        // <MedicationListTable />
                    )
                }
            </div>
        </div>
    );
};

export default MedicationPage;
